import { useFeatureGate } from '@trello/feature-gate-client';

/**
 * Hook to check if the localizeCount refactor feature gate is enabled.
 *
 * This hook is used during the migration away from the deprecated `localizeCount`
 * function to ensure the refactored implementation is properly gated.
 *
 * @returns true if the refactor feature gate is enabled, false otherwise
 */

export const useIsLocalizeCountRefactorEnabled = (): boolean => {
  const { value: isEnabled } = useFeatureGate('phx_localize_count_refactor');

  return isEnabled;
};
